/**
 * The site's identity, in one place. Every absolute URL, address and
 * endpoint the landing page uses is read from here.
 *
 * PLACEHOLDERS, owner to confirm before launch:
 * - SITE_URL: `bellclub.app` has NOT been checked for availability or
 *   trademark. public/index.html, public/manifest.json and public/j/index.html
 *   cannot import this file; they spell the same origin and must move with it
 *   (grep for bellclub.app).
 */
export const SITE_NAME = 'Bell Club';
export const SITE_URL = 'https://bellclub.app';
export const SUPPORT_EMAIL = 'support@bellclub.app';

// The app on the App Store: its Apple ID (App Store Connect → App
// Information), the production app's `submit.production.ios.ascAppId` in
// eas.json - never the bundle id. public/index.html (the Smart App Banner)
// and public/j/index.html spell the same id; src/__tests__/launch.test.js
// holds all three to eas.json.
export const APP_STORE_ID = '6821433558';
export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_ID}`;

// Apple's "Download on the App Store" badge, black (the preferred badge),
// exactly as Apple's marketing tools serve it - never edited, recoloured or
// redrawn (launch.test.js pins its bytes). Apple: one badge per layout, at
// least 40 px tall, clear space a quarter of its height on every side.
export const APP_STORE_BADGE = '/badges/download-on-the-app-store-black.svg';

// Pricing shown on the page. RevenueCat's localised price is what the app's
// paywall shows; these are the USD list prices (BELL_CLUB_BUILD.md §1).
export const PRICES = {
  monthly: '$6.99',
  yearly: '$49.99',
  trialDays: 7,
};
